import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from '../theme/ThemeService';

@Component({
    selector: 'cas-header',
    template: `
        <header class="cl-header">
            <span [ngClass]="primaryClass">{{ primary }}</span><span class="force-space text-contrast">{{ contrast }}</span>
        </header>
    `
})
export class CasHeaderComponent implements OnInit {
    @Input() public primary: string;
    @Input() public contrast: string;

    public primaryClass: string;

    constructor(
        private themeService: ThemeService
    ) {
    }

    public ngOnInit() {
        this.primaryClass = this.themeService.getTextAccentClass();
    }
}
